import Route from '@ember/routing/route';
import { inject as service } from '@ember/service'

import {
  GET_TOKEN,
  GET_ORIGIN,
  GET_LEGACY_TOKEN,
  GET_LEGACY_EMAIL,
  GET_LEGACY_USER_ID,
} from 'sh-www/controllers/verify-email';

const LEGACY_VERIFY_EMAIL_PARAMS = [
  GET_LEGACY_TOKEN,
  GET_LEGACY_EMAIL,
  GET_LEGACY_USER_ID,
];

/** @module */
class VerifyEmailRoute extends Route {
  @service session;
  @service('error-tracker')
  errorTracker;

  queryParams = [GET_TOKEN, GET_ORIGIN, GET_LEGACY_TOKEN, GET_LEGACY_EMAIL, GET_LEGACY_USER_ID].reduce((accum, key) => {
    accum[key] = { replace: true };
    return accum;
  }, { });

  /** @inheritDoc */
  model(_, transition) {
    const { queryParams } = transition.to;

    try {
      const model = Object.keys(queryParams).reduce((accum, key) => {
        accum[key] = atob(queryParams[key]);
        return accum;
      }, { });

      // ensure all required params exist
      if (!model[GET_TOKEN] && !model[GET_LEGACY_TOKEN]) {
        throw new Error('missing token');
      } else if (!model[GET_ORIGIN]) {
        throw new Error('missing origin');
      } else if (model[GET_LEGACY_TOKEN]) {
        LEGACY_VERIFY_EMAIL_PARAMS.forEach((param) => {
          if (!model[param]) {
            throw new Error(`missing verify email param: [${param}]`);
          }
        });
      }

      return model;
    } catch (e) {
      this.errorTracker.error('error trying to validate email', this, e);
      throw e;
    }
  }

  setupController(controller, { token, t, e, u, o }) {
    super.setupController(...arguments);

    controller.setProperties({
      userId: u,
      email: e,
      origin: o,
    });

    // fallback to legacy token
    const tokenParam = token ?? t;

    controller.verifyEmailTask.perform(tokenParam, e);
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.verifyEmailTask.cancelAll({ resetState: true });
      controller.resendVerifyEmailTask.cancelAll({ resetState: true });

      controller.setProperties({
        [GET_TOKEN]: null,
        [GET_ORIGIN]: null,
        [GET_LEGACY_TOKEN]: null,
        [GET_LEGACY_EMAIL]: null,
        [GET_LEGACY_USER_ID]: null,
      });
    }
  }
}

export default VerifyEmailRoute;
